<template>
  <div>
    <accounts-component />
  </div>
</template>
<script>
export default {
  name: "AccountsView",
};
</script>